export const getCarContractABTest = (): false => {
	const config = document.querySelector('[data-hook="3453_0"]')?.getAttribute('data-variant');
	return config ? JSON.parse(config).configOverlay || false : false;
};
